export function slugToSuburbName(slug: string): string {
  return slug
    .split('-')
    .map((segment) =>
      segment.length === 0 ? segment : segment[0].toUpperCase() + segment.slice(1),
    )
    .join(' ');
}

export function getSuburbSlug(name: string): string {
  if (!name) return '';

  const cleanName = name.trim().toLowerCase();

  switch (cleanName) {
    case 'commercial property in toowoomba city: office, retail & mixed-use':
    case 'commercial property toowoomba city':
    case 'commercial property in toowoomba city':
    case 'toowoomba city':
    case 'toowoomba':
      return 'toowoomba-city';

    case 'commercial property in harlaxton: retail & light industry':
    case 'commercial property in harlaxton':
    case 'commercial property harlaxton':
    case 'harlaxton':
      return 'harlaxton';

    case 'commercial property in highfields: retail, medical & office':
    case 'commercial property in highfields':
    case 'commercial property highfields':
    case 'highfields':
      return 'highfields';

    case 'commercial property in gatton: agriculture, education & logistics':
    case 'commercial property in gatton':
    case 'commercial property gatton':
    case 'gatton':
      return 'gatton';

    case 'commercial property in warwick: industrial & rural services':
    case 'commercial property in warwick':
    case 'commercial property warwick':
    case 'warwick':
      return 'warwick';

    case 'commercial property in dalby: resources, agriculture & freight':
    case 'commercial property in dalby':
    case 'commercial property dalby':
    case 'dalby':
      return 'dalby';

    case 'torrington industrial real estate property: warehouses, sheds & transport depots':
    case 'industrial property torrington':
    case 'industrial property in torrington':
    case 'commercial property in torrington':
    case 'torrington':
      return 'torrington';

    case 'retail and industrial properties in north toowoomba':
    case 'retail property north toowoomba':
    case 'retail property in north toowoomba':
    case 'commercial property in north toowoomba':
    case 'north toowoomba':
    case 'north-toowoomba':
      return 'north-toowoomba';

    case 'industrial land and development properties in rockville':
    case 'industrial land rockville':
    case 'industrial land in rockville':
    case 'commercial property in rockville':
    case 'rockville':
      return 'rockville';

    case 'warehouses and industrial properties in property wellcamp, toowoomba':
    case 'industrial property wellcamp, toowoomba':
    case 'industrial property wellcamp':
    case 'industrial property in wellcamp':
    case 'commercial property in wellcamp':
    case 'wellcamp':
      return 'wellcamp';

    case 'industrial property in wilsonton city':
    case 'industrial property wilsonton | warehouses & medical suites':
    case 'industrial property wilsonton':
    case 'industrial property in wilsonton':
    case 'commercial property in wilsonton':
    case 'wilsonton':
      return 'wilsonton';

    default: {
      if (cleanName.includes('north toowoomba')) return 'north-toowoomba';
      if (cleanName.includes('toowoomba')) return 'toowoomba-city';
      if (cleanName.includes('harlaxton')) return 'harlaxton';
      if (cleanName.includes('highfields')) return 'highfields';
      if (cleanName.includes('gatton')) return 'gatton';
      if (cleanName.includes('warwick')) return 'warwick';
      if (cleanName.includes('dalby')) return 'dalby';
      if (cleanName.includes('torrington')) return 'torrington';
      if (cleanName.includes('rockville')) return 'rockville';
      if (cleanName.includes('wellcamp')) return 'wellcamp';
      if (cleanName.includes('wilsonton')) return 'wilsonton';

      return cleanName.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
    }
  }
}
